/**
 * Created by Administrador on 07/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('profileUserCtrl', profileUserCtrl);

    profileUserCtrl.$inject = ['linkService','profileUserService','profileUser','datePickerService','dateService'];

    function profileUserCtrl(linkService, profileUserService, profileUser,datePickerService,dateService){
        var vm = this;
        vm.profileUser = profileUser.data.profile;
        vm.profileUser.birthDate = vm.profileUser.birthDate?dateService.getDateByDateZone(vm.profileUser.birthDate): new Date(1960,0,1);
        vm.profileUser.nroIdentify = vm.profileUser.nroIdentify?parseInt(vm.profileUser.nroIdentify,10): null;
        vm.profileUser.phones = setPhones(vm.profileUser.phone);

        vm.datePickerOpenStatus = {'birthDate': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                maxDate: new Date()
            }
        };
        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.save = function(isValid){
            if (isValid) {
                vm.profileUser.phone = getPhone(vm.profileUser.phones);
                profileUserService.updateProfile(vm.profileUser)
                    .then(function(){
                        linkService.reloadRoute('dashboard');
                    });
            }
        }

        vm.addPhones = function(){
            vm.profileUser.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.profileUser.phones.splice(index, 1)
        }

        vm.changeHandler = function (form) {
            if(form.birthDate.$modelValue != undefined && !isNaN(form.birthDate.$modelValue)){
                form.birthDate.$setValidity('dateLessThanToday', vm.profileUser.birthDate.getTime() <= vm.datepickerFrom.datepickerOptions.maxDate.getTime());
            }else{
                form.birthDate.$setValidity('date', false);
            }
        }

        function getPhone(phones){
            var res = '';
            angular.forEach(phones, function(phone){
                res = res+(res.length==0?'':',')+phone.prefix+'-'+phone.number
            });
            return res;
        }

        function setPhones(phone){
            var res = [];
            if(phone == null){
                res = [
                    {
                        prefix: '',
                        number: ''
                    }
                ]
            }else{
                angular.forEach(phone.split(','), function(splitPhone){
                    res.push({
                        'prefix': splitPhone.split('-')[0],
                        'number': splitPhone.split('-')[1]
                    });
                });
            }
            return res;
        }
    }
})();
